export default {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  TUMBLR: 'tumblr',
  LINK: 'link',
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/social-networks.js